<template>
  <v-menu
    @input="toggleGuestsMenu"
    offset-y
    nudge-bottom="6"
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :class="buttonClass"
        depressed
        :style="buttonStyle"
      >
        <v-icon size="18" class="mr-2">mdi-account-outline</v-icon>
        <span class="text-capitalize">
          {{
            adults + children > 0
              ? adults + children + " " + $t("guests")
              : $t("guests")
          }}
        </span>
      </v-btn>
    </template>
    <v-card min-width="200">
      <v-card-text>
        <div class="d-flex font-weight-semibold mb-2">
          <span class="me-6">{{ $t("adults") }}</span>
          <count-picker :value.sync="adults" />
        </div>
        <div class="d-flex font-weight-semibold">
          <span class="me-2">{{ $t("children") }}</span>
          <count-picker :value.sync="children" :min="0" />
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CountPicker from "@/components/common/count-picker.vue";

export default {
  name: "guests-selector",
  components: {
    CountPicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ adults: 2, children: 0 }),
    },
    buttonClass: {
      type: String,
      default:
        "d-none d-md-flex flex justify-center justify-md-start text-caption count-button",
    },
    buttonStyle: {
      type: Object,
      default: () => ({ minWidth: "120px", width: "22%" }),
    },
    isMobileOrIPad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adults: this.value.adults || 2,
      children: this.value.children || 0,
    };
  },
  methods: {
    toggleGuestsMenu(val) {
      if (!val) {
        this.$emit("input", {
          adults: this.adults,
          children: this.children,
        });
      }
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.adults = newVal.adults || 2;
        this.children = newVal.children || 0;
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.count-button {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px !important;
  background-color: white !important;
}
</style>
